export default __webpack_public_path__ + "static/media/26.0889eaf3.jpg";